import { ShieldAlert, ShieldCheck, TriangleAlert } from "lucide-react";
import type { LintFinding } from "@shared/newsletterTypes";

/**
 * Errors block launch (the server refuses it too; this is the friendly copy).
 * Warnings never block: whether four data points identify a company in a small
 * market is a judgment call, and the person sending it is the one to make it.
 */
export function LintPanel({ findings, checked }: { findings: LintFinding[]; checked: boolean }) {
  const errors = findings.filter((f) => f.level === "error");
  const warnings = findings.filter((f) => f.level === "warning");

  if (!checked) return null;

  if (errors.length === 0 && warnings.length === 0) {
    return (
      <div className="flex items-start gap-2 rounded-lg border border-green-600/30 bg-green-600/5 p-3">
        <ShieldCheck className="w-4 h-4 text-green-600 dark:text-green-400 mt-0.5 shrink-0" />
        <p className="text-sm">No client is identifiable from this issue.</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {errors.length > 0 && (
        <div className="flex items-start gap-2 rounded-lg border border-destructive/40 bg-destructive/5 p-3">
          <ShieldAlert className="w-4 h-4 text-destructive mt-0.5 shrink-0" />
          <div className="space-y-1">
            <p className="text-sm font-medium">Fix before sending</p>
            {errors.map((f, i) => <p key={i} className="text-sm text-muted-foreground">{f.message}</p>)}
          </div>
        </div>
      )}
      {warnings.length > 0 && (
        <div className="flex items-start gap-2 rounded-lg border border-amber-500/40 bg-amber-500/5 p-3">
          <TriangleAlert className="w-4 h-4 text-amber-600 dark:text-amber-400 mt-0.5 shrink-0" />
          <div className="space-y-1">
            <p className="text-sm font-medium">Worth a look</p>
            {warnings.map((f, i) => <p key={i} className="text-sm text-muted-foreground">{f.message}</p>)}
          </div>
        </div>
      )}
    </div>
  );
}
